var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qm-swiper',{attrs:{"swiperStyle":"y","imgList":_vm.imgList,"lunboTime":null,"width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }